import { styled } from '@mui/material';
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import { selectSidebarOpen, setSidebar } from '../../features/Users/userSlice';
import { useDispatch, useSelector } from 'react-redux';
import CustomDrawer from '../../common/CustomDrawer';
import { Box } from '@mui/material';
import { selectDrawerOpen } from '../../features/Search/searchSlice';
import PermissionManager from '../../features/Users/components/PermissionManager';
import UserSettings from '../../features/Users/components/UserSettings';
import { useEffect, useLayoutEffect } from 'react';

const Main = styled('main')(({ theme, open, width }) => ({
  flexGrow: 1,
  border: '0px solid black',
  transition: 'none',
  marginRight: open ? 5 : -width,
  width: '100%',
  maxWidth: '100%',
  overflowX: 'hidden',
  position: 'relative',
  [theme.breakpoints.down('lg')]: {
    marginRight: 0,
    width: '100%',
  },
}));

const Right = () => {
  const open = useSelector(selectDrawerOpen);
  const sidebarOpen = useSelector(selectSidebarOpen);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const active = pathname.split('/')[2] == 'user';
  const dispatch = useDispatch();

  const handleBackClick = () => {
    dispatch(setSidebar({ value: false }));
    navigate('user');
  };

  useLayoutEffect(() => {
    if (!active) {
      dispatch(setSidebar({ value: false }));
    }
  }, [active]);
  const { empCode } = useParams();
  const permissionOpen = pathname?.split('/').includes('permissions');
  const content = Boolean(empCode) ? <UserSettings /> : <PermissionManager />;

  return (
    <Box sx={{ display: 'flex', padding: 1, width: '100%' }}>
      <Main open={Boolean(sidebarOpen || permissionOpen)} width={open ? 750 : 950}>
        <Outlet />
      </Main>
      <CustomDrawer
        height='calc(100vh - 80px)'
        width={open ? 750 : 950}
        open={Boolean(sidebarOpen || permissionOpen)}
        back={true}
        handleBackClick={handleBackClick}
        content={content}
        top={'60px'}
      />
    </Box>
  );
};

export default Right;
